import { ELEMENTS } from './axes.constants';

const { TOP, BOTTOM, LEFT, RIGHT } = ELEMENTS;

export const adjustAutoSpace = (element, type, setSpace) => {
  setTimeout(() => {
    const { width, height } = element.getBBox();

    if (type === TOP || type === BOTTOM) {
      setSpace(type, height);
    }

    if (type === LEFT || type === RIGHT) {
      setSpace(type, width);
    }
  }, 0);
};
